import {
  Button,
  Flex,
  Input,
  InputGroup,
  InputLeftElement,
} from '@chakra-ui/react';
import { debounce } from 'lodash';
import { Search } from 'lucide-react';
import { memo, useEffect, useMemo } from 'react';

interface RosterHeaderProps {
  onSearchChange: (query: string) => void;
  onAddClick: () => void;
}

export const RosterHeader = memo(function RosterHeader({
  onSearchChange,
  onAddClick,
}: RosterHeaderProps) {
  const onSearchChangeDebounced = useMemo(
    () => debounce(onSearchChange, 300),
    [onSearchChange]
  );

  useEffect(() => {
    return () => {
      onSearchChangeDebounced.cancel();
    };
  }, [onSearchChangeDebounced]);

  return (
    <Flex alignItems="center" justifyContent="space-between" mb={4}>
      <InputGroup maxWidth="300px">
        <InputLeftElement height="48px" pointerEvents="none">
          <Search color="rgba(255,255,255,0.4)" size={16} />
        </InputLeftElement>
        <Input
          bg="whiteAlpha.50"
          border="1px solid"
          borderColor="whiteAlpha.100"
          color="white"
          placeholder="Search agents"
          onChange={(e) => onSearchChangeDebounced(e.target.value)}
        />
      </InputGroup>

      <Button
        _hover={{ bg: 'cyan.600' }}
        bg="cyan.500"
        size="sm"
        onClick={onAddClick}
      >
        Add
      </Button>
    </Flex>
  );
});
